import React from "react";
import { Repeat } from "lucide-react";
import { getNextOccurrences } from "../utils/recurrencePreview";

const RepeatPreview = ({ task }) => {
    const occurrences = getNextOccurrences(task, 5);
    if (!occurrences.length) return null;

    return (
        <div className="mt-4 rounded-xl border border-line bg-surface-2 p-3">
            <div className="flex items-center gap-2 mb-2">
                <Repeat size={14} className="text-primary" />
                <h3 className="text-xs font-semibold uppercase tracking-wide text-ink-muted">
                    Next occurrences
                </h3>
            </div>
            <ul className="space-y-1">
                {occurrences.map((occ, i) => (
                    <li
                        key={i}
                        className="text-xs text-ink-secondary py-1 border-b border-line last:border-0"
                    >
                        {occ.label}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default RepeatPreview;
